/**
 * `/entity/*` routes v2 calls (API_ACCESS.md §3.1), held to the snapshot by `api/routes.test.ts`.
 */
import { anySession } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

export const ENTITY = defineRoutes("entity", {
  fetchAll: route<undefined, unknown, { entityName: string }>("GET", "/entity/:entityName/fetchAll", anySession(), {
    notes:
      "every record of one business entity; `catalog/fetch` reads `itemtag` (P1 slice 4). v1's session bootstrap reads it too until New Order's cutover",
  }),
});
